import {
  ApolloLink as ApolloLinkV3,
  createHttpLink as createHttpLinkV3,
  Observable as ObservableV3,
} from '@apollo/client';
import {onError as onErrorV3} from '@apollo/client/link/error';
import {RetryLink as RetryLinkV3} from '@apollo/client/link/retry';
import {
  ApolloLink as ApolloLinkV2,
  Observable as ObservableV2,
} from 'apollo-link';
import {onError as onErrorV2} from 'apollo-link-error';
import {createHttpLink as createHttpLinkV2} from 'apollo-link-http';
import {RetryLink as RetryLinkV2} from 'apollo-link-retry';

import {isApolloClientV3Enabled} from '../../apolloRuntime';

export const ApolloLink = (
  isApolloClientV3Enabled ? ApolloLinkV3 : ApolloLinkV2
) as typeof ApolloLinkV3;
export const Observable = (
  isApolloClientV3Enabled ? ObservableV3 : ObservableV2
) as typeof ObservableV3;
export const createHttpLink = (
  isApolloClientV3Enabled ? createHttpLinkV3 : createHttpLinkV2
) as typeof createHttpLinkV3;
export const onError = (
  isApolloClientV3Enabled ? onErrorV3 : onErrorV2
) as typeof onErrorV3;
export const RetryLink = (
  isApolloClientV3Enabled ? RetryLinkV3 : RetryLinkV2
) as typeof RetryLinkV3;

export type {FetchResult, Observer, Operation} from '@apollo/client';
